<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="UserName"
  >
  
    <div class="text-right leading-tight hidden sm:block">
      <!--<p class="font-semibold">{{ activeUserInfo.displayName }}</p>-->
      <p class="font-semibold">{{ UserName }}</p>
      <small>{{ getUserName }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="UserProfilePic"
          key="onlineImg"
          :src="UserProfilePic"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <!--<img v-else key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <feather-icon v-else icon="UserIcon" width="40" height="40" class="rounded-full shadow-md cursor-pointer block"/>-->
        <vs-icon v-else icon="account_circle" size="40px"></vs-icon>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown" id="nav-bar-dropdown">
        <ul style="min-width: 9rem">
          <!--
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>
          -->

          <!--<li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/email').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/todo').catch(() => {})">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>

          <vs-divider class="m-1" />-->

          <li
            v-if="Session_Event_FullName != null && !IsGeoCheckinEnabled"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="startTour"
          >
            <feather-icon icon="NavigationIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Start Tour</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import ls from "@/common/localStorage";
import { bus } from "../../../../main";
import con from "@/firebase/firebaseInit.ts";

export default {
  data() {
    return {
      UserName: ls.getSessionValueByKey("Name"),
      UserProfilePic: ls.getSessionValueByKey("ProfilePictureURL"),
      Session_Event_FullName: ls.getSessionValueByKey("Session_Event_FullName"),
      IsGeoCheckinEnabled: ls.getSessionValueByKey("UseOnlyGeoCheckinModule"),
    };
  },
  computed: {
    getUserName() {
      let name = "";
      if (ls.getSessionValueByKey("Role") == 1) name = "Super Admin";
      else if (ls.getSessionValueByKey("Role") == 2) name = "Client Admin";
      if (ls.getSessionValueByKey("Role") == 3) name = "Event Admin";
      else if (ls.getSessionValueByKey("Role") == 4) name = "Analytics Admin";

      return name;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    logout() {
      // if user is logged in via auth0
      if (this.$auth.profile) this.$auth.logOut();

      // if user is logged in via firebase
      const firebaseCurrentUser = firebase.auth().currentUser;

      if (firebaseCurrentUser) {
        firebase
          .auth()
          .signOut()
          .then(() => {
              location.href = "/pages/login";
            
            //this.$router.push('/pages/login').catch(() => {})
          });
      }
      // If JWT login
      if (localStorage.getItem("accessToken")) {
        localStorage.removeItem("accessToken");
              location.href = "/pages/login";
        //this.$router.push('/pages/login').catch(() => {})
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change("admin");
      localStorage.removeItem("userInfo");

      if (ls.checkLogin()) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            ls.sessionLogOut();
              location.href = "/pages/login";

            
            //this.$router.push('/pages/login').catch(() => {})
          });
      }

      // This is just for demo Purpose. If user clicks on logout -> redirect
      //this.$router.push('/pages/login').catch(() => {})
    },
    startTour() {
      document.getElementById("nav-bar-dropdown").style.display = "none";
      this.$router.push('/event/overview/tour').catch(() => {})
      setTimeout(function(){ bus.$emit("startMainTour", true); }, 500);
      
    },
  },
};
</script>
